import { render, staticRenderFns } from "./FooterDots.vue?vue&type=template&id=3902ab9e&"
import script from "./FooterDots.vue?vue&type=script&lang=js&"
export * from "./FooterDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports